<template>
  <el-dialog title="确认付款" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="620px">
    <el-form size="small" :model="form" :rules="formRules" ref="form" :label-width="formLabelWidth">
      <el-form-item label="付款金额" prop="payPrice">
        <el-input v-model="form.payPrice" autocomplete="off" type="number" style="width: 340px;" placeholder="请输入付款金额"></el-input>
      </el-form-item>
      <el-form-item label="付款时间" prop="payTime">
          <el-date-picker
            placeholder="请选择付款时间"
            style="width: 340px;"
            size="small"
            v-model="form.payTime"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
      </el-form-item>
      <el-form-item label="付款凭证" prop="image">
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image" >
            <transition-group>
              <div class="item" v-for="(item, index) in form.image" :key="item.filePath">
                <img v-img-url="item.filePath" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openProductUpload('image', 'image')"><i class="el-icon-plus"></i></div>
        </div>
        <!--商品图片组件-->
        <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
      </el-form-item>

      <el-form-item label="备注" prop="paymentRemark">
        <el-input type="textarea" :rows="4" v-model="form.paymentRemark" style="width: 340px;" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="confirmPaymentUpdate" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Upload from '@/components/file/Upload';
  import OrderApi from '@/api/order.js';
  export default {
    components: {
      Upload,
    },
    data() {
      return {
        form: {
          payPrice: null,
          payTime: null,
          paymentRemark: '',
          image: []

        },
        filePath: '',
        formRules: {
          payPrice: [{
            required: true,
            message: '请输入付款金额',
            trigger: 'blur'
          }],
          payTime: [{
            required: true,
            message: '请选择付款时间',
            trigger: 'blur'
          }],
          image: [{
            required: true,
            message: '请上传付款凭证',
            trigger: 'blur'
          }],
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        isProductUpload: false,
      };
    },
    props: ['open_confirm_payment', 'ConfirmPaymentModel'],
    created() {
      if(this.ConfirmPaymentModel.paymentRemark){
        this.form.paymentRemark = this.ConfirmPaymentModel.paymentRemark
      }
      if(this.ConfirmPaymentModel.paymentVoucherJsonArray&&this.ConfirmPaymentModel.paymentVoucherJsonArray.length){
        this.form.image = this.ConfirmPaymentModel.paymentVoucherJsonArray
      }
      this.dialogVisible = this.open_confirm_payment;
    },
    methods: {
      /*提交*/
      confirmPaymentUpdate() {
        let self = this;
        let params = this.form;
        params.orderId = self.ConfirmPaymentModel.orderId
        console.log(params)
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            OrderApi.confirmPayment(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，付款成功',
                  type: 'success'
                });
                this.dialogVisible = false;
              })
              .catch(error => {
                self.loading = false;
                this.dialogVisible = false;
              });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*删除商品图片*/
      deleteImg(index) {
        this.form.image.splice(index, 1);
      },
      /*打开上传图片*/
      openProductUpload: function(file_type, file_name) {
        this.file_name = file_name;
        if (file_type == 'image') {
          this.config = {
            total: 9,
            fileType: 'image'
          };
        } else {
          this.config = {
            total: 1,
            fileType: 'video'
          };
        }
        this.isProductUpload = true;
      },

      /*上传商品图片*/
      returnProductImgsFunc(e) {
        if (e != null) {
          if (this.file_name == 'video') {
            this.form.videoId = e[0].fileId;
            this.form.videoFilePath = e[0].filePath;
          } else if (this.file_name == 'image') {
            let imgs = this.form.image.concat(e);
            // 兼容后端
            for (let i = 0; i < imgs.length; i++) {
              if (typeof(imageId) == "undefined") {
                this.$set(imgs[i], 'imageId', imgs[i].fileId);
              }
            }
            this.$set(this.form, 'image', imgs);
          } else if (this.file_name == 'poster') {
            this.form.posterId = e[0].fileId;
            this.form.posterFilePath = e[0].filePath;
          }
        }
        this.isProductUpload = false;
      }
    }
  };
</script>

<style>
  .img {
    margin-top: 10px;
  }
  .draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/deviceorder/dialog/ConfirmPayment.vue